import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { forwardRef } from 'react';
import { Select as AriaSelect, Button, Group, SelectValue } from 'react-aria-components';
import { useController } from 'react-hook-form';
import { DropdownItem, ListBox } from './dropdown';
import { Label } from './label';
import { Popover } from './popover';

export const UncontrolledSelect = forwardRef(function Select(
  { label, options, placeholder = '', ...props },
  ref,
) {
  return (
    <AriaSelect
      {...props}
      placeholder={placeholder}
      ref={ref}
      className="group flex flex-col gap-1 relative"
    >
      <Label>{label}</Label>
      <Button
        name={props.name}
        className="h-10.5 text-body-dark hover:text-body-dark rounded-md border border-solid border-300 shadow-sm placeholder:text-light-500 focus-within:ring-1 ring-primary focus-within:border-primary bg-white"
      >
        <Group className="flex items-center relative justify-stretch w-full">
          <SelectValue className="data-[placeholder=true]:px-2 data-[placeholder=true]:text-light-500">
            {({ defaultChildren }) => defaultChildren}
          </SelectValue>
          <ChevronDownIcon
            className="absolute right-2 top-1/2 -translate-y-2.5 size-5 pointer-events-none text-light-400 grow-0"
            aria-hidden="true"
          />
        </Group>
      </Button>
      <Popover className="w-[--trigger-width]">
        <ListBox
          items={options}
          className="outline-hidden box-border p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]"
        >
          {({ value, label, disabled }) => (
            <DropdownItem id={value} textValue={label} disabled={disabled}>
              {label}
            </DropdownItem>
          )}
        </ListBox>
      </Popover>
    </AriaSelect>
  );
});

export function Select(props) {
  const { field } = useController({ name: props.name });
  return <UncontrolledSelect {...props} {...field} isDisabled={props.disabled} />;
}
